import { createStore, Store } from 'redux';
import { OneFormState } from 'src/types';
import { initialState, oneFormReducer } from './feature-app/redux';

export const rootStore: Store<OneFormState> = createStore(
	oneFormReducer,
	initialState,
);
